export const types: OptionType[] = [
  { value: '', label: 'All Types' },
  { value: 'email', label: 'Email' },
  { value: 'product_info', label: 'Product Info' },
  { value: 'sms', label: 'SMS' },
  { value: 'phone', label: 'Phone' },
  { value: 'orchestrator', label: 'Orchestrator' },
  { value: 'orchestrator_system', label: 'Orchestrator System' },
  {
    value: 'communicator_validator',
    label: 'Communicator Validator',
  },
  { value: 'campaign_strategy', label: 'Campaign Strategy' },
];
